import { Url } from '../shared/Url';
import Post from '../shared/Post';

import { consultaUser } from './PefilFunction';

export const consultaDataUser = (respuesta) => {
    let leerCookie = (nombre) => {
        let lista = document.cookie.split(";");
        let micookie;
        let igual;
        let valor;
        for (let i in lista) {
          let busca = lista[i].search(nombre);
          if (busca > -1) {micookie=lista[i]}
        }
        
        if (micookie === undefined) return null;
        
        igual = micookie.indexOf("=");
        valor = micookie.substring(igual + 1);
        return valor;
    }

    let valor = leerCookie("U_ID");

    /* let valor = "";
    let lista = document.cookie.split(";");
    for (let i = 0; i <= lista.length; i++){
        if (lista[i] !== undefined) {
            let item = lista[i].split("=");
            if (item[0] === " U_ID"){
              valor = item[1];
            }
        }
    } */

    let Content = {
        uId: valor,
    }

    Post(`${Url}consultUserEst`, Content, (resp) => {
        let data = JSON.parse(resp);
        let notificacionClass = "custom-alert-info";
        let notificacionIcon = "fa fa-circle-o-notch fa-spin";
        let notificacionText = "Verificando Información, espera por favor";
        let notificacionPeriodo = "";

        switch (parseInt(data.status)) {
            case 0:
                notificacionClass = "custom-alert-info";
                notificacionIcon = "fa fa-exclamation-triangle";
                notificacionText = "No estas inscrito";
                break;
            case 1:
                notificacionClass = "custom-alert-warning";
                notificacionIcon = "fa fa-exclamation-triangle";
                notificacionText = "Pendiente de Formalizar el Pago";
                break;
            case 2:
                notificacionClass = "custom-alert-danger";
                notificacionIcon = "fa fa-times";
                notificacionText = "Inscripción no aprobada";
                break;
            case 3:
                notificacionClass = "custom-alert-success";
                notificacionIcon = "fa fa-check";
                notificacionText = "Inscripción completada";
                break;
            case 4:
                notificacionClass = "custom-alert-danger";
                notificacionIcon = "fa fa-times";
                notificacionText = "Pen";
                break;
            case 5:
                notificacionClass = "custom-alert-warning";
                notificacionIcon = "fa fa-exclamation-triangle";
                notificacionText = "Pendiente de Aprobación de Control de Estudios";
                break;
            case 6:
                notificacionClass = "custom-alert-danger";
                notificacionIcon = "fa fa-exclamation-triangle";
                notificacionText = "No Tienes Estado de Cuenta";
                break;
            case 7:
                notificacionClass = "custom-alert-danger";
                notificacionIcon = "fa fa-exclamation-triangle";
                notificacionText = "Actualmente tienes una Deuda Pendiente";
                break;
            case 8:
                notificacionClass = "custom-alert-danger";
                notificacionIcon = "fa fa-exclamation-triangle";
                notificacionText = "Actualmente tienes una Deuda Pendiente";
                break;
            default:
                notificacionClass = "custom-alert-warning";
                notificacionIcon = "fa fa-exclamation-triangle";
                notificacionText = "No estas inscrito";
                break;
        }

        let semestres = [];
        let dataSemestres = data.semestres
        for (let i in dataSemestres) {
            semestres.push({
                value: dataSemestres[i].id,
                label: dataSemestres[i].semestre_name,
            })
        }

        let materiasInsc = [];
        let uc = 0;
        let dataInscritas = data.inscritas

        for (let i in dataInscritas) {
            
            let DatosSeccion = [
                dataInscritas[i].materia_id,
                {
                    materia: dataInscritas[i].materia_name,
                    seccion: dataInscritas[i].nombre,
                    tipo: dataInscritas[i].tipo_curso,
                    tipoM: {
                        value: dataInscritas[i].tipo_curso,
                        label: dataInscritas[i].tipoev_name
                    }
                },
                dataInscritas[i].u_c,
                dataInscritas[i].bs,
                {
                    value: dataInscritas[i].semId,
                    label: dataInscritas[i].semName
                }
            ]

            uc += parseInt(dataInscritas[i].u_c);
            materiasInsc.push(
                DatosSeccion
            )
        }

        let meses = ["Enero", "Febrer0", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

        if (data.AdminPeriodoId !== "") notificacionPeriodo = `Tu admisión es válida para el periodo ${meses[parseInt(data.AdminPeriodoM - 1)]} - ${data.AdminPeriodoY}`;
        let state = {
            dataInscripcion: data.carrera,
            semestres: semestres,
            notificacionClass: notificacionClass,
            notificacionIcon: notificacionIcon,
            notificacionText: notificacionText,
            seccionesSelectFull: materiasInsc,
            seccionesSelectFull2: materiasInsc,
            cr: uc,
            notificacionPeriodo: notificacionPeriodo,
            periodoAct: `${meses[parseInt(data.PeriodoM - 1)]} - ${data.PeriodoY}`,
            tipoInsc: data.Inscripcion,
            costoInsc: data.CInscripcion,
            InscripcionDatos: data.inscripcionDat,
            datosPersonales: data.datosPErsonales,
            boton1: { Icon:"fa fa-check", Title:"Confirmar", disabled: false}
        }

        respuesta([
            state,
            parseInt(data.status),
            uc,
            data.status,
            data.AdminEst,
            data.CMat,
            data.Cuotas,
            data.CuotaName,
            data.CMat2
        ]);
    }); 

}

export const consultaDataUser2 = (respuesta) => {
    let leerCookie = (nombre) => {
        let lista = document.cookie.split(";");
        let micookie;
        let igual;
        let valor;
        for (let i in lista) {
          let busca = lista[i].search(nombre);
          if (busca > -1) {micookie=lista[i]}
        }
        
        if (micookie === undefined) return null;
        
        igual = micookie.indexOf("=");
        valor = micookie.substring(igual + 1);
        return valor;
    }

    let valor = leerCookie("U_ID");

    let Content = {
        uId: valor,
    }

    Post(`${Url}consultUserEst`, Content, (resp) => {
        let data = JSON.parse(resp);
        let semestres = [];
        let dataSemestres = data.semestres
        for (let i in dataSemestres) {
            semestres.push({
                value: dataSemestres[i].id,
                label: dataSemestres[i].semestre_name,
            })
        }

        let materiasInsc = [];
        let uc = 0;
        let dataInscritas = data.inscritas

        for (let i in dataInscritas) {
            
            let DatosSeccion = [
                dataInscritas[i].materia_id,
                {
                    materia: dataInscritas[i].materia_name,
                    seccion: dataInscritas[i].nombre,
                    tipo: dataInscritas[i].tipo_curso,
                    tipoM: {
                        value: dataInscritas[i].tipo_curso,
                        label: dataInscritas[i].tipoev_name
                    }
                },
                dataInscritas[i].u_c,
                dataInscritas[i].bs,
                {
                    value: dataInscritas[i].semId,
                    label: dataInscritas[i].semName
                }
            ]

            uc += parseInt(dataInscritas[i].u_c);
            materiasInsc.push(
                DatosSeccion
            )
        }

        let meses = ["Enero", "Febrer0", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

        let state = {
            seccionesSelectFull: materiasInsc,
            periodoAct: `${meses[parseInt(data.PeriodoM - 1)]} - ${data.PeriodoY}`,
            tipoInsc: data.Inscripcion,
            costoInsc: data.CInscripcion,
            InscripcionDatos: data.inscripcionDat,
            datosPersonales: data.datosPErsonales
        }

        respuesta([
            state,
            parseInt(data.status),
            uc,
            data.status,
            data.AdminEst,
            data.CMat,
            data.Cuotas,
            data.CuotaName
        ]);
    }); 

}

export const consultaOferta = (estudiante, id, respuesta) => {
    
    /* consultaUser((estudiante) => { */
        let Content = {
            est: estudiante,
            id: id,
        }

        Post(`${Url}consultaOferta`, Content, (resp) => {
            let dat = JSON.parse(resp);
            let data = dat.oferta;
            let electivas = dat.electCursadas;
            let cursadas = 0;
            let aprobadas = 0;

            for (let i in electivas) {
                cursadas++;
                if (parseInt(electivas[i].nota) >= parseInt(electivas[i].nota_min)) aprobadas++
            }

            let contenido= [];
            for (let i in data) {
                contenido.push({
                    materia: data[i].seccion.materia_name,
                    seccion: data[i].seccion.nombre,
                    tipo_mat: data[i].seccion.tipomat_name,
                    uc: data[i].seccion.u_c,
                    cupos: parseInt(data[i].seccion.cupos) - parseInt(data[i].inscritos),
                    prof: `${data[i].seccion.nombre_1} ${data[i].seccion.apellido_1}`,
                    aula: data[i].seccion.aula,
                    seccionId: data[i].seccion.id,
                    materiaId: data[i].seccion.materia_id,
                    HoraIn: data[i].seccion.hora_in,
                    HoraOut: data[i].seccion.hora_out,
                })
            }

            respuesta([contenido, cursadas, aprobadas]);
        });
    /* }); */
}

export const consultaOfertaDir = (id, estudiante, respuesta) => {
    
    let Content = {
        est: estudiante,
        id: id,
    }

    Post(`${Url}consultaOferta`, Content, (resp) => {
        let dat = JSON.parse(resp);
        let data = dat.oferta;

        let contenido= [];
        for (let i in data) {
            contenido.push({
                materia: data[i].seccion.materia_name,
                seccion: data[i].seccion.nombre,
                tipo_mat: data[i].seccion.tipomat_name,
                uc: data[i].seccion.u_c,
                cupos: parseInt(data[i].seccion.cupos) - parseInt(data[i].inscritos),
                prof: `${data[i].seccion.nombre_1} ${data[i].seccion.apellido_1}`,
                aula: data[i].seccion.aula,
                seccionId: data[i].seccion.id,
                materiaId: data[i].seccion.materia_id,
            })
        }

        respuesta([contenido]);
    });
}

export const Inscribir = (campos, uc, respuesta) => {
    consultaUser((estudiante) => {
        Post(`${Url}preferencias`, "", (resp) => {
            let data = JSON.parse(resp);
            let UcMin = data[0][0].min_uc;
            let UcMax = data[0][0].max_uc;
            let MateMin = data[0][0].min_mate;
            let MateMax = data[0][0].max_mate;
            let MateInscritas = campos.seccionesSelectFull.length;
            let Materias = campos.seccionesSelectFull;
            let Dia = campos.valorCita.value;
            let notificacionText = "Te has inscrito correctamente, para completar el proceso por favor imprime la planilla";
            let typeNotificacion = "info";
    
            /* Validaciones */
            let errores = 0;
            if (UcMin === 0 && UcMax === 0){
                errores = errores
            }else{
                if (uc < UcMin) {
                    notificacionText = `El mínimo de Unidades de Crédito que puedes inscribir es [ ${UcMin} ]`
                    typeNotificacion = "error";
                    errores++;
                }
                if (uc > UcMax) {
                    notificacionText = `El máximo de Unidades de Crédito que puedes inscribir es [ ${UcMax} ]`
                    typeNotificacion = "error";
                    errores++;
                }
            }
    
            if (MateMin === 0 && MateMax === 0){
                errores = errores
            }else{
                if (MateInscritas < MateMin) {
                    notificacionText = `El mínimo de Materias que puedes inscribir es [ ${MateMin} ]`
                    typeNotificacion = "error";
                    errores++;
                }
                if (MateInscritas > MateMax) {
                    notificacionText = `El máximo de Materias que puedes inscribir es [ ${MateMax} ]`
                    typeNotificacion = "error";
                    errores++;
                }
            }
    
            if (errores === 0) {
                if (Dia === "") {
                    notificacionText = "Debes seleccionar el día de la inscripción"
                    typeNotificacion = "error";
                    errores++;

                    let state = {
                        Text: notificacionText,
                        Type: typeNotificacion,
                        errores: errores
                    }
            
                    respuesta(state);
                }else{
                    let Content = {
                        UcMin: UcMin,
                        UcMax: UcMax,
                        MateMin: MateMin,
                        MateMax: MateMax,
                        MateInscritas: MateInscritas,
                        Uc: uc,
                        Est: estudiante,
                        Materias: Materias,
                        Dia: Dia
                    }

                    /* console.log(Content) */
        
                    Post(`${Url}addInscripcion`, Content, (resp) => {
                        let data = JSON.parse(resp);
                        let state = "";
                        if(data.status === "sc") {
                            state = {
                                Text: "No se agregaron las materias debido a que una o mas secciones se encuentran sin cupos disponibles, presiona F5 para recargar",
                                Type: "error",
                                MateMax: MateMax,
                                errores: 1
                            }
                        }else{
                            state = {
                                Text: notificacionText,
                                Type: typeNotificacion,
                                MateMax: MateMax,
                                errores: errores
                            }
                        }
    
                        respuesta(state);
                    });
                }
            }else{
                let state = {
                    Text: notificacionText,
                    Type: typeNotificacion,
                    errores: errores
                }
        
                respuesta(state);
            }
        });
    })
}

export const Seccion = (id, respuesta) => {
    let idMat = "";
    if (id.id === undefined) {
        idMat = id;
    }else{
        idMat = id.id;
    }

    consultaUser((estudiante) => {
        let Content = {
            id: idMat,
            idEst: estudiante
        }

        Post(`${Url}verSeccion`, Content, (resp) => {
            let data1 = JSON.parse(resp);
            let data = data1[0]/* [0] */;
            let tipo = "";
            
            if (data1[2] === 0){
                let contTipos = data1[4];
                for (let i in contTipos){
                    if (contTipos[i].id === parseInt(id.tipo)) tipo = contTipos[i].tipoev_name
                }
                /* switch (parseInt(id.tipo)) {
                    case 0:
                        tipo = 'Presencial';
                        break;
                    case 1:
                        tipo = 'Prueba de Suficiencia' ;
                        break;
                    default:
                        tipo = 'Presencial';
                        break;
                } */
            }else if (data1[2] === 1){
                let contTipos = data1[4];
                for (let i in contTipos){
                    if (contTipos[i].id === parseInt(data1[3])) tipo = contTipos[i].tipoev_name
                }
                /* switch (parseInt(data1[3])) {
                    case 0:
                        tipo = 'Presencial';
                        break;
                    case 1:
                        tipo = 'Prueba de Suficiencia' ;
                        break;
                    default:
                        tipo = 'Presencial';
                        break;
                } */
            }
            
            let contenido= {
                materia: data.materia_name,
                seccion: data.nombre,
                tipo: tipo,
                uc: data.u_c,
                semestre: data.semestre_name,
                bs: data1[5],
            };

            respuesta(contenido)
        });
    });
}

export const SeccionDir = (est, id, respuesta) => {
    let idMat = "";
    if (id.id === undefined) {
        idMat = id;
    }else{
        idMat = id.id;
    }

    
    let Content = {
        id: idMat,
        idEst: est
    }


    Post(`${Url}verSeccion`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0]/* [0] */;
        let tipo = "";
        
        if (data1[2] === 0){
            let contTipos = data1[4];
            for (let i in contTipos){
                if (contTipos[i].id === idMat.tipo) tipo = contTipos[i].tipoev_name
            }
            /* switch (parseInt(id.tipo)) {
                case 0:
                    tipo = 'Presencial';
                    break;
                case 1:
                    tipo = 'Prueba de Suficiencia' ;
                    break;
                default:
                    tipo = 'Presencial';
                    break;
            } */
        }else if (data1[2] === 1){
            let contTipos = data1[4];
            for (let i in contTipos){
                if (contTipos[i].id === parseInt(data1[3])) tipo = contTipos[i].tipoev_name
            }
            /* switch (parseInt(data1[3])) {
                case 0:
                    tipo = 'Presencial';
                    break;
                case 1:
                    tipo = 'Prueba de Suficiencia' ;
                    break;
                default:
                    tipo = 'Presencial';
                    break;
            } */
        }
        
        let contenido= {
            materia: data.materia_name,
            seccion: data.nombre,
            tipo: tipo,
            uc: data.u_c,
            semestre: data.semestre_name,
        };

        respuesta(contenido)
    });
    
}

export const consultaMatInscrita = (estudiante, id, respuesta) => {
    /* consultaUser((estudiante) => { */
        let Content = {
            Id: id,
            Est: estudiante,
        }
        Post(`${Url}consultaMatInscrita`, Content, (resp) => {
            let check = false;
            let data = JSON.parse(resp);

            let valorTipo = { value: parseInt(data.tipo), label: data.tipo_name }
            
            let tipos = []
            let contTipos = data.tipos;
            for (let i in contTipos){
                if (contTipos[i].abrev !== null)
                tipos.push({
                    value: parseInt(contTipos[i].id), label: contTipos[i].tipoev_name 
                })
            }

            if (data.status === 1) check = true;
            respuesta([check, parseInt(data.uc), data.status, valorTipo, tipos, parseFloat(data.valor)])
        });
    /* }); */
}

export const consultaMatInscritaDir = (id, estudiante, respuesta) => {
    let Content = {
        Id: id,
        Est: estudiante,
    }
    Post(`${Url}consultaMatInscrita`, Content, (resp) => {
        let check = false;
        let data = JSON.parse(resp);


        let valorTipo = { value: parseInt(data.tipo), label: data.tipo_name }
            
        let tipos = []
        let contTipos = data.tipos;
        for (let i in contTipos){
            tipos.push({
                value: parseInt(contTipos[i].id), label: contTipos[i].tipoev_name 
            })
        }


        /* let valorlabel = ""
        switch (parseInt(data.tipo)) {
            case 0:
                valorlabel = 'Presencial';
                break;
            case 1:
                valorlabel = 'Prueba de Suficiencia' ;
                break;
            default:
                valorlabel = 'Presencial';
                break;
        }


        let valorTipo = { value: parseInt(data.tipo), label: valorlabel } */


        if (data.status === 1) check = true;
        respuesta([check, parseInt(data.uc), data.status, valorTipo, tipos, parseFloat(data.valor)])
    });
}

export const verEstudianesInsc = (id, respuesta) => {
    let Content = {
        seccion: id,
    }
    Post(`${Url}verEstudiantesSec`, Content, (resp) => {
        let data = JSON.parse(resp);
        let contenido = []
        let cont = data.estudiantes;
        for (let i in cont){
            let nombre2 = "";
            let apellido2 = "";
            if(cont[i].nombre_2 !== null) nombre2 = cont[i].nombre_2;
            if(cont[i].apellido_2 !== null) apellido2 = cont[i].apellido_2;

            contenido.push({
                ci: cont[i].ci,
                nombre1: cont[i].nombre_1,
                nombre2: nombre2,
                apellido1: cont[i].apellido_1,
                apellido2: apellido2
            })
        }
        


        respuesta(contenido)
    });
}

export const ConsultDatosEst = (respuesta) => {
    consultaUser((estudiante) => {
        let Content = {
            id: estudiante,
        }

        Post(`${Url}consultEstudiante`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta([data[0], data[1]])
        });
    });
}

export const InfoUC = (respuesta) => {
    consultaUser((estudiante) => {
        let Content = {
            id: estudiante,
        }

        Post(`${Url}infoUC`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    });
}

export const InfoPago = (respuesta) => {
    Post(`${Url}InfoPago`, "", (resp) => {
        let data = JSON.parse(resp);
        respuesta(data[0])
    });
}

export const ConsultDiasDisp = (respuesta) => {
    Post(`${Url}diasInscripcion`, "", (resp) => {
        let data = JSON.parse(resp);
        let cont = data[0];
        let contenido = [];

        for (let i in cont){
            contenido.push({
                value: cont[i].id, label: cont[i].dia 
            })
        }

        respuesta(contenido)
    });
}


// WEBPACK FOOTER //
// ./src/funciones/InscripcionFunction.jsx